import { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { useNavigate } from 'react-router-dom';
import logo from './logo.svg'; // Importa il logo
// Rimuovi l'importazione del CSS originale
// import './GestioneStati.css';
import './tailwind.css';
import { FaLock } from 'react-icons/fa'; // Icona per la password

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Questa parte è cruciale per il reset password:
    // Supabase reindirizza l'utente a questo URL con un access_token nel frammento URL (#access_token=...)
    // Il client Supabase (supabaseClient.js) lo gestisce automaticamente, ma è bene sapere che accade.
    // Puoi anche usare onAuthStateChange per catturare la sessione dopo il reindirizzamento.
    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        // L'utente è ora autenticato (temporaneamente) tramite il link di reset.
        // Ora può impostare la nuova password.
        // Se l'utente fosse "admin" con first_login, potresti anche reindirizzarlo a /forced-password-change
        // per mantenere la coerenza, ma dato che è un reset esplicito, questa pagina è adatta.
      } else {
        // Se non c'è sessione, e la pagina viene caricata direttamente,
        // non c'è token per il reset, quindi reindirizziamo al login.
        if (!window.location.hash.includes('access_token')) {
            // navigate('/'); // Potresti voler reindirizzare solo se non c'è hash nella URL
        }
      }
    });

    return () => {
      if (authListener && typeof authListener.unsubscribe === 'function') {
        authListener.unsubscribe();
      }
    };
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword !== confirmPassword) {
      setError('Le password non corrispondono.');
      return;
    }

    if (newPassword.length < 6) {
      setError('La password deve essere di almeno 6 caratteri.');
      return;
    }

    try {
      // Usa updateUser per impostare la nuova password dell'utente loggato (tramite token URL)
      const { error: updateError } = await supabase.auth.updateUser({
        password: newPassword
      });

      if (updateError) {
        console.error('Errore nell\'aggiornamento della password:', updateError.message);
        setError(`Errore nell'aggiornamento della password: ${updateError.message}. Il link potrebbe essere scaduto o non valido.`);
        return;
      }

      setSuccess('Password aggiornata con successo! Verrai reindirizzato alla pagina di login.');
      setTimeout(() => {
        navigate('/'); // Reindirizza al login dopo il reset
      }, 2000);

    } catch (err) {
      console.error('Errore imprevisto nel reset password:', err.message);
      setError('Si è verificato un errore imprevisto. Riprova.');
    }
  };

  return (
    // Main container, centered on screen
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      {/* Content wrapper, max width for readability and shadow for visual depth */}
      <div className="bg-white p-8 rounded-lg shadow-xl text-center max-w-md w-full">
        <img src={logo} alt="Europassistance" className="mb-4 mx-auto h-20" />
        <h1 className="text-2xl md:text-2xl text-mioblu mb-4 flex items-center justify-center font-semibold uppercase">
          <FaLock className="mr-3 text-red-600 text-3xl" /> Reimposta la tua Password
        </h1>
        <p className="text-gray-600 mb-6 text-sm">
          Inserisci la tua nuova password.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          {error && (
            <p className="text-miorosso text-sm mb-2">{error}</p>
          )}
          {success && (
            <p className="text-green-500 text-sm mb-2">{success}</p>
          )}

          <label htmlFor="new-password" className="text-left text-gray-700 font-medium text-sm">Nuova Password:</label>
          <input
            id="new-password"
            type="password"
            placeholder="Minimo 6 caratteri"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-gray-800"
          />

          <label htmlFor="confirm-password" className="text-left text-gray-700 font-medium text-sm">Conferma Nuova Password:</label>
          <input
            id="confirm-password"
            type="password"
            placeholder="Conferma Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-gray-800"
          />

          <button
            type="submit"
            className="w-full px-4 py-2 bg-miorosso text-white rounded-md transition-colors duration-300 hover:bg-mioblu focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 font-semibold mt-4"
          >
            RIPRISTINA
          </button>
        </form>
      </div>
    </div>
  );
}
